import { render } from "./PatientInfo.vue?vue&type=template&id=13eb0b22&scoped=true"
import script from "./PatientInfo.vue?vue&type=script&lang=js"
export * from "./PatientInfo.vue?vue&type=script&lang=js"

import "./PatientInfo.vue?vue&type=style&index=0&id=13eb0b22&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13eb0b22"]])

export default __exports__